import React, { useEffect, useState } from "react";
import LineAnimation from "../assets/img/Snake_line_loop.gif";

const DataTransferAnimatedModal = ({ showModal, onHide, message = "Moving", transferring, movingData }) => {
  const [animation, setAnimation] = useState(false);
  useEffect(() => {
    if (transferring == true) {
      setAnimation(transferring);
    } else {
      // setTimeout(() => {
        setAnimation(false);
      // }, 1000);
    }
  }, [transferring]);

  // if (!movingData) return;

  let transferUser = movingData?.transfer || null;
  let receiverUser = movingData?.receiver || null;

  return (
    <div show={showModal} onHide={onHide} centered className="assign-modal">
      {animation ? (
        <>
          <div className="data-animation">
            {renderProfile(transferUser)}
            <div className="lines-animated">
              <img src={LineAnimation} alt="" referrerPolicy={"no-referrer"} />
            </div>
            {renderProfile(receiverUser)}
          </div>
          <p className="info-msg"> {message} </p>
        </>
      ) : (
        <>
          <div className="assign-success">
            <svg
              className="checkmark-bg"
              width="107"
              height="107"
              viewBox="0 0 107 107"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.2" filter="url(#filter0_f_3929_7234)">
                <ellipse cx="53.8632" cy="53.8637" rx="30.1586" ry="30.1586" fill="#81FE9D" />
              </g>
              <defs>
                <filter
                  id="filter0_f_3929_7234"
                  x="0.757118"
                  y="0.757607"
                  width="106.212"
                  height="106.212"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="11.4737" result="effect1_foregroundBlur_3929_7234" />
                </filter>
              </defs>
            </svg>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
              <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>

            <h6>{message}</h6>
          </div>
        </>
      )
      }
    </div >
  );
};

export default DataTransferAnimatedModal;

export const renderProfile = (user) => {
  const isGroup = user.type === "group";
  const singleUser = user.data.length === 1;

  return (
    <div className="profile-box-parent">
      <div className="profile-box">
        <span className={singleUser ? `profile-image ${isGroup ? "group" : ""}` : `profile-image-multipe ${isGroup ? "group" : ""}`}>
          {user.data.slice(0, singleUser ? 1 : 3).map((u, index) => (
            u.avatar ? (
              <img key={index} src={u.avatar} alt="avatar" referrerPolicy={"no-referrer"} />
            ) : (
              <span key={index} className="init">
                {u?.name?.split(" ").slice(0, 2).map(e => e?.at(0)).join("").toUpperCase() || ""}
              </span>
            )
          ))}
        </span>
      </div>
      <span className="profile-border"><span className="profile-border-child"></span></span>
      <span className="profile-border n"><span className="profile-border-child"></span></span>
    </div>
  );
};

